import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import DataTable from '../../shared/components/DataTable';
import {
  fetchStudents,
  deleteStudent,
} from '../../redux/actions/studentsActions';
import Confirm from '../../shared/components/Confirm';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { createErrorMessage, createSuccessMessage } from '../../helpers/notification';

class StudentsContainer extends PureComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      pageSize: 25,
      totalItemsCount: 0,
      loading: true,
      items: [],
      filters: { id: 20 },
    };
    this.columns = [
      {
        key: 'numeroLegajo',
        name: '# Legajo',
        width: '80px',
        search: true,
        type: 'number',
      },
      {
        key: 'numeroDocumento',
        name: '# Documento',
        search: true,
        type: 'number',
        width: '110px',
      },
      { key: 'nombre', name: 'Nombre', search: true },
      { key: 'apellido', name: 'Apellido', search: true },
      { key: 'malla', name: 'Malla', search: true },
      { key: 'carrera', name: 'Carrera', search: true },
      { key: 'actions', name: 'Accion', width: '85px' },
    ];
    this.actions = [
      {
        key: 'viewAcademicStatus',
        icon: <span className="fa fa-eye" title="Ver estado académico" />,
        callback: (student) => {
          this.handleViewAcademicStatusStudent(student);
        },
      },
      {
        key: 'edit',
        icon: <span className="fa fa-edit" title="Editar alumno" />,
        callback: (student) => {
          this.editStudent(student);
        },
      },
      {
        key: 'delete',
        icon: <span className="fa fa-trash" title="Borrar alumno" />,
        callback: (student) => {
          this.handleDeleteStudent(student);
        },
      },
    ];
  }

  componentDidMount() {
    const { page, pageSize } = this.state;
    this.updateStudentsTable(page, pageSize);
  }

  updateStudentsTable = (page, pageSize, filters = {}) => {
    this.setState({
      loading: true,
      page,
      pageSize,
      filters: filters || {},
    });

    const { numeroLegajo } = filters;

    fetchStudents({
      pageInfo: {
        page,
        pageSize,
        filters: {
          ...filters,
          numeroLegajo: numeroLegajo ? +numeroLegajo : null,
        },
      },
      onSuccess: (pageInfo) => {
        this.setState({
          loading: false,
          items: pageInfo.items,
          totalItemsCount: pageInfo.totalItemsCount,
        });
      },
      onError: () => {
        this.setState({ items: [], loading: false });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  handleDeleteStudent = (student) => {
    const name = `${student.nombre} ${student.apellido}`;
    Confirm({
      title: 'Borrar alumno',
      question: `Estás seguro que deseas eliminar a ${name}?`,
      yesLabel: 'Si, Borrar alumno',
      noLabel: 'No, Volver',
      onConfirm: () => {
        deleteStudent(student.id,
          {
            onSuccess: () => {
              createSuccessMessage('Alumno borrado exitosamente');
              const { page, pageSize } = this.state;
              this.updateStudentsTable(page, pageSize);
            },
            onError: (error) => {
              if (error && error.status === 404) {
                createErrorMessage('El alumno no existe');
              } else {
                createErrorMessage('Error al intentar borrar el alumno');
              }
            },
          });
      },
    });
  };

  handleViewAcademicStatusStudent = (student) => {
    const { history } = this.props;
    history.push(`/pages/reporte-alumnos/academic-status/${student.id}`);
  };

  editStudent = (student) => {
    const { history } = this.props;
    history.push(`/pages/students/edit/${student.id}`);
  };

  onChangePage = (page) => {
    if (page) {
      const { pageSize, filters } = this.state;
      this.updateStudentsTable(page, pageSize, filters);
    }
  };

  onDataTableSubmit = (values) => {
    if (values) {
      const { pageSize } = this.state;
      this.updateStudentsTable(1, pageSize, values);
    }
  };


  onDataTableClearFilters = () => {
    const { pageSize } = this.state;
    this.updateStudentsTable(1, pageSize, {});
  };

  getGridActions = (key) => {
    const actions = {
      actions: this.actions,
    };
    return actions[key];
  }

  render() {
    const {
      loading,
      items,
      page,
      pageSize,
      totalItemsCount,
      filters,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">Alumnos del Sistema</h3>
            <div className="card__title">
              <Link className="btn btn-primary" to="/pages/students/new">
                <i className="fa fa-plus" /> Agregar nuevo alumno
              </Link>
            </div>
          </Col>
        </Row>
        <Row>
          {loading ? <LoadingSpinner />
            : (
              <DataTable
                title="Listado de todos los alumnos de la universidad"
                columns={this.columns}
                items={items}
                onChangePage={this.onChangePage}
                page={page}
                pageSize={pageSize}
                totalItemsCount={totalItemsCount}
                getGridActions={key => this.getGridActions(key)}
                onSubmit={this.onDataTableSubmit}
                onClearFilters={this.onDataTableClearFilters}
                initialValues={filters}
                enableReinitialize
              />
            )
          }
        </Row>
      </Container>
    );
  }
}

export default withRouter(StudentsContainer);
